/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface LabControllerRemove$Params {
  labId: string;
}

export function labControllerRemove(http: HttpClient, rootUrl: string, params: LabControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, labControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('labId', params.labId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

labControllerRemove.PATH = '/lab/{labId}';
